"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stringify = exports.parse = void 0;

var _qs = _interopRequireDefault(require("qs"));

var _lodash = _interopRequireDefault(require("lodash.isempty"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @module query */

/**
 * This method parse a query string into object
 * @param {String} str the string to parse
 * @returns {Object} the query object parsed from query string
 * @example
 * // returns {str1: "hello", str2: "hola"}
 * parse("?str1=hello&str2=hola")
 * @example
 * // returns {name: "John", lastName: "Doe"}
 * parse("name=John&lastName=Doe")
 * @memberof query
 */
var parse = function parse() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return !(0, _lodash.default)(str) ? _qs.default.parse(str.replace(/^\?/, "")) : {};
};
/**
 * This method stringify object into query string
 * @param {Object} obj the object to be stringify
 * @returns {String} the stringified query result
 * @example
 * // returns "?name=John&lastName=Doe"
 * stringify({name: "John", lastName: "Doe"})
 * @memberof query
 */


exports.parse = parse;

var stringify = function stringify() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return !(0, _lodash.default)(obj) ? "?".concat(_qs.default.stringify(obj)) : "";
};

exports.stringify = stringify;